import { action, computed, makeObservable, observable } from "mobx";
import { PublicAppSubStore, PublicAppSubStoreArgs } from "@/store/types";

export enum SystemPermissionsModal {
  Voice = "voice",
  Meeting = "meeting",
  /**
   * Includes full-disk access for microsoft teams meeting detection.
   */
  AdvancedMeeting = "advanced-meeting",
}

export class AppStoreSystemPermissionsUiStore extends PublicAppSubStore {
  activeModal: SystemPermissionsModal | null = null;

  constructor(injectedDeps: PublicAppSubStoreArgs) {
    super(injectedDeps);

    makeObservable<AppStoreSystemPermissionsUiStore>(this, {
      activeModal: observable,
      isVoiceModalOpen: computed,
      isMeetingModalOpen: computed,
      isAdvancedMeetingModalOpen: computed,
      isAnyModalOpen: computed,
      openModal: action,
      openVoicePermissionsModal: action,
      openMeetingPermissionsModal: action,
      openAdvancedMeetingPermissionsModal: action,
      closeModal: action,
      resetState: action,
    });
  }

  get isVoiceModalOpen(): boolean {
    return this.activeModal === SystemPermissionsModal.Voice;
  }

  get isMeetingModalOpen(): boolean {
    return this.activeModal === SystemPermissionsModal.Meeting;
  }

  get isAdvancedMeetingModalOpen(): boolean {
    return this.activeModal === SystemPermissionsModal.AdvancedMeeting;
  }

  get isAnyModalOpen(): boolean {
    return this.activeModal !== null;
  }

  openModal(modal: SystemPermissionsModal): void {
    this.activeModal = modal;
  }

  openVoicePermissionsModal = (): void => {
    this.openModal(SystemPermissionsModal.Voice);
  };

  openMeetingPermissionsModal = (): void => {
    this.openModal(SystemPermissionsModal.Meeting);
  };

  openAdvancedMeetingPermissionsModal = (): void => {
    this.openModal(SystemPermissionsModal.AdvancedMeeting);
  };

  closeModal = (): void => {
    this.activeModal = null;
  };

  resetState = (): void => {
    this.activeModal = null;
  };
}
